/** Valor em reais no padrão brasileiro ("R$ 25,80"). */
export const formatBRL = (value: number): string =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
